import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { ApiService } from 'merlin-library';
import { ClinicianApiEndPointConstants } from '../../utilitites/api-end-point-constants';

@Injectable({
  providedIn: 'root',
})
export class BaselineClinicalDataService {
    public token = localStorage.getItem('token')

  constructor(private apiService: ApiService, private http: HttpClient) {}

        getData(patientid){
          return this.apiService.get(`${ClinicianApiEndPointConstants.getClinicData}?patientId=${patientid}`)
        }

        updateData(data){
          return this.apiService.put(`${ClinicianApiEndPointConstants.updateData}`,data)
        }
  }
